module.exports = __webpack_public_path__ + "img/logo.a2683454.png";